export default "__VITE_ASSET__cFA4EnKm__"